/**
 * Tracks which bottom-anchored overlays (release notes, NPS) are on screen so
 * lower-priority ones such as feature announcements can stay out of the way.
 */
type Listener = () => void;

const visibleSurfaces = new Set<string>();
const listeners = new Set<Listener>();
let snapshot: readonly string[] = [];

function emit() {
  snapshot = [...visibleSurfaces];
  listeners.forEach((listener) => listener());
}

export function setFloatingSurfaceVisible(id: string, isVisible: boolean): void {
  if (isVisible === visibleSurfaces.has(id)) return;
  if (isVisible) {
    visibleSurfaces.add(id);
  } else {
    visibleSurfaces.delete(id);
  }
  emit();
}

export function subscribeFloatingSurfaces(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getVisibleFloatingSurfaces(): readonly string[] {
  return snapshot;
}

const EMPTY: readonly string[] = [];

export function getServerVisibleFloatingSurfaces(): readonly string[] {
  return EMPTY;
}

export function resetFloatingSurfaces(): void {
  visibleSurfaces.clear();
  emit();
}
